import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./layout/Layout";

import HomePage from "./HomePage";
import Register from "./pages/Register";
import RegisterGoogle from "./pages/RegisterGoogle";
import CookiePolicy from "./pages/CookiePolicy";
import LegalDraftPage from "./pages/LegalDraftPage";
import AccountType from "./pages/AccountType";
import Admin from "./admin/Admin";
import ProfileSetup from "./components/ProfileSetup";
import AdminLogin from "./admin/AdminLogin";
import MyProfile from "./pages/MyProfile";
import Support from "./pages/Support";
import QuickQuestions from "./pages/QuickQuestions";
import AccountSettings from "./pages/AccountSettings";
import { LanguageProvider } from "./i18n";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>

        <Routes>

         <Route path="/admin/login" element={<AdminLogin />} />
         <Route path="/admin/*" element={<Admin />} />

          {/* Toutes les pages passent par Layout */}
          <Route element={<Layout />}>

            <Route path="/" element={<HomePage />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register-google" element={<RegisterGoogle />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/profile"
             element={<ProfileSetup onClose={() => window.history.back()} />} />
            <Route path="/my-profile" element={<MyProfile />} />
            <Route path="/account-settings" element={<AccountSettings />} />
            <Route path="/support" element={<Support />} />
            <Route path="/quick-questions" element={<QuickQuestions />} />
            <Route path="/account-type" element={<AccountType />} />
            <Route path="/legal-preview" element={<LegalDraftPage />} />
            <Route path="/terms" element={<LegalDraftPage documentId="us" />} />
            <Route path="/terms/california" element={<LegalDraftPage documentId="california" />} />
            <Route path="/terms/colorado" element={<LegalDraftPage documentId="colorado" />} />
            <Route path="/terms/new-york" element={<LegalDraftPage documentId="newyork" />} />
            <Route path="/safety/colorado" element={<LegalDraftPage documentId="safety" />} />

          </Route>

        </Routes>

        {/* reCAPTCHA global */}
        <div id="recaptcha-container"></div>

      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
